$.plugins.fontstrip = {
	animate: false,
	_value: null,
	_delta: 0,
	_scale: null,

	__scale: {
		factor: 50,
		max: 4.25,
		min: 0,
	},

	__format: function(value, scale) {
		if (typeof scale === 'undefined' || scale === null) {
			value = Math.floor(value);
			scale = true;
		}

		else if (typeof scale === 'number' && scale > 0) {
			if (scale <= .1) {
				value = Math.floor(value / (scale * 1000) * 100) / 100;
				scale = false;
			}

			else {
				value = Math.floor(value / scale);
			}
		}

		else if (scale === false) {
			value = Math.floor(value / 100 * 100) / 100;
			scale = false;
		}

		else {
			value = Math.floor(value) / 100;
			scale = false;
		}

		var parts = value.toFixed(scale ? 0 : 2).split('.');
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		value = parts.join('.');

		return value;
	},

	__init: function(config) {
		if (config.label === undefined) {
			config.label = '';
		}
		this.apply('widget', { label: config.label, value: true }).addClass('fontstrip');

		if (typeof config.value !== 'undefined') {
			this.set(config.value);
		}

		if (config.animate) {
			this.animate = true;
		}

		this.characters = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, '$', '.', ',' ];
		if (config.characters) {
			this.characters = config.characters;
		}

		this.characters = this.characters.map(function(char) {
			return char = char.toString();
		});

		this.field.pieces = [];
		this.field.length = 0;
	},

	scale: function(value) {
		this._scale = value;

		return this.update();
	},

	inc: function(value, immediate) {
		this.set(this._value + value, immediate);
	},

	set: function(value, immediate) {
		if (value === true) {
			return this.set(this._value, true);
		}
		if (value === null || value === undefined) {
			value = 0;
		}

		this._base = this._value || 0;
		this._value = value;
		this._delta = this._value - this._base;

		if (!this._value || this._delta <= 0) {
			immediate = true;
		}

		if (this.animate && this._value && immediate !== true) {
			if (immediate && immediate.hasOwnProperty('progress')) {
				this._track = immediate;
			}

			else {
				var meterdata = $.plugins.meter.__scale;
				var scale = 1;

				if (immediate && immediate.scale) {
					scale = typeof immediate.scale === 'number' ? immediate.scale : this._scale;
				}

				var seconds = typeof immediate === 'number' ? immediate : ((meterdata.max - meterdata.min) * (1 - Math.exp(-this._delta / (scale * meterdata.factor))) + meterdata.min);

				this._frames = Math.ceil(seconds * 24);
				this._frame = 0;
			}

			this.timer = setInterval(this.update.bind(this), 1000 / 24);
		}

		else {
			return this.update();
		}
	},

	update: function(force) {
		var value = this._value;

		if (typeof value === 'number') {
			if (!force && this.animate) {
				var progress = 1;

				if (this._track) {
					progress = this._track.progress;
				}

				else if (this._frames) {
					progress = this._frame++ / this._frames;
				}

				if (typeof progress !== 'number' || progress >= 1) {
					progress = 1;
					force = true;
				}

				value = this._base + this._delta * progress;
			}

			value = $.plugins.meter.__format(value, this._scale);
		}

		if (typeof this.max !== 'undefined') {
			value = value + ' of ' + this.max;
		}
		var val = 0;

		if (value || value === 0) {
			val = value.toString();
		}
		this._length = val.length;

		var change_divs = this._length - this.field.length;

		if (change_divs > 0) {
			/* add more divs */
			for (var i = 0; i < change_divs; i++) {
				this.field.pieces.push($.div().appendTo(this.field));
				this.field.length++;
			}
		}
		else if (change_divs < 0) {
			/* remove divs */
			for (var i = 0; i < Math.abs(change_divs); i++) {
				this.field.pieces.shift().remove();
				this.field.length--;
			}
		}

		for (var i = 0; i < this.field.length; i++) {
			var index = this.characters.indexOf(val[i]);

			this.field.pieces[i].css('background-position', +(index / (this.characters.length - 1)) * 100 + '%');
			this.field.pieces[i].attr('class', '_' + index);
		}

		if (this.animate && force && (this._frames || this._track)) {
			this.timer = clearInterval(this.timer);
			delete this._frames;
			delete this._track;

			this.trigger('done');
		}

		return this;
	},

	font: function(number) {

	},

	isReady: function() {
		if (this._track) {
			return this._track.progress >= 1;
		}

		else {
			return !this._frames;
		}
	},
};



/** WEBPACK FOOTER **
 ** ./../../../../engine/public-src/spingames/panel/js/fontstrip.js
 **/